module.exports = __webpack_public_path__ + "img/icon_instagram_rotate_neg.22d88b28.svg";